// Phone helpers — separate country code from 10-digit local number.
// We display them separately everywhere ("+91" pill + 10-digit local).

const ALLOWED_CC = ["+91", "+1", "+44", "+61", "+971", "+65"];

export function splitPhone(raw) {
  if (!raw) return { cc: "+91", local: "" };
  const s = String(raw).trim();
  for (const cc of ALLOWED_CC) {
    if (s.startsWith(cc)) return { cc, local: s.slice(cc.length).replace(/\D/g, "") };
  }
  // legacy formats: "919876543210" → +91 9876543210
  const digits = s.replace(/\D/g, "");
  if (digits.length === 12 && digits.startsWith("91")) return { cc: "+91", local: digits.slice(2) };
  if (digits.length === 10) return { cc: "+91", local: digits };
  return { cc: "+91", local: digits };
}

export function joinPhone(cc, local) {
  const l = (local || "").replace(/\D/g, "");
  return `${cc}${l}`;
}

export function formatPhoneDisplay(raw) {
  const { cc, local } = splitPhone(raw);
  if (!local) return "";
  // Pretty 5-5 grouping for Indian numbers, 3-3-4 for US, fallback to plain
  if (cc === "+91" && local.length === 10) return `${cc} ${local.slice(0, 5)} ${local.slice(5)}`;
  return `${cc} ${local}`;
}

export const COUNTRY_CODES = ALLOWED_CC;
